// Global Instructions Rule Applied! - 2026-04-20

import { store } from '../../state_manager/store.ts'

/**
 * Resolves a lookup_details id to its label using `globalConfigs.lookup_headers` (same data as `useLookups` / InputManager).
 */
export function getLookupLabelFromGlobalConfig(detailId: string): string {
  if (!detailId) return ''
  const headers = store.getState().globalConfigs?.lookup_headers ?? []
  for (const header of headers) {
    const found = header.details?.find((d) => d.id === detailId)
    if (found) return found.label
  }
  return ''
}

export function getAccountRoleChoiceLabelById(id: string): string {
  if (!id) return ''
  const choices = store.getState().globalConfigs?.account_role_choices ?? []
  const found = choices.find((c) => c.id === id)
  return found?.role ?? ''
}

export function getFundNameById(id: string): string {
  if (!id) return ''
  const funds = store.getState().globalConfigs?.funds ?? []
  const found = funds.find((f) => f.id === id)
  return found?.name ?? ''
}

export function getPipelineStageNameById(id: string): string {
  if (!id) return ''
  const stages = store.getState().globalConfigs?.pipeline_stages ?? []
  const found = stages.find((s) => s.id === id)
  return found?.name ?? ''
}
